<template>
  <b-card>
    <!-- form -->
      <b-form class="mt-2">
        <b-row>
          <b-col sm="6">
            <b-form-group
                :label="$t('Api Key')"
                label-for="name"
              >
                <b-form-input
                  v-model="apikey"
                  readonly
                />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-button
              @click="generateApiKey"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mt-2 mr-1"
              >
              {{ $t('Generate Api Key') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
  </b-card>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BAlert, BCard, BCardText, BLink, BModal, VBModal
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Apicall from '@/libs/api-call'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BAlert,
    BCard,
    BCardText,
    BLink,
    BModal,
    VBModal,
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  props: {
    apikey: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
    }
  },
  methods: {
    generateApiKey() {

          const api = new Apicall();
          api.generateApiKey().then(response => {
            if (response.status === 'OK') {
              console.log(response.data);
              this.apikey = response.data.data;
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  variant: 'success',
                  title: this.$t('message.oneFieldUpdatedSuccess', {'_field_':this.$t('Api Key')}),
                  icon: 'CheckIcon'
                },
              });
            } else {
              if (response.statuscode === 401) this.$router.push('Login');
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  variant: 'danger',
                  title: this.$t(response.msg),
                  icon: 'XIcon',
                },
              });
            }
          });        
    },
  }
}
</script>
<style scoped>
.form-group .iti{
  position: relative;
  display: flex;
}
.v-select.form-control{
  padding: 0rem;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>